interface MetaRoute {
    title: string;
    to:string;
    description: string;
    keywords: string;
    priority: number;
}
export const routesMap ={
   home: {
    title: "דף הבית | משלים פלוס לחיים",
    priority: 1,
    to: "/",
    description: "ברוכים הבאים למשלים – שירותי רפואה עד הבית, בדיקות, ייעוץ מומחים וטיפול אישי לכל גיל",
    keywords: "משלים, משלים פלוס לחיים,רפואה עד הבית, שירותי בריאות, בדיקות שגרתיות, ייעוץ רפואי, רופא משפחה, שירות רפואי אישי, טיפול רפואי, שירותי חירום, רופא אונליין, תרופות עד הבית, ייעוץ מומחים, מרפאות, שירות רפואי למשפחה, שירות רפואי לילדים, תמיכה רפואית 24/7"
  },
   contactus: {
    title: "צור קשר",
    to: "/contactus",
    description: "צרו קשר עם משלים לשאלות, תמיכה או מידע נוסף. אנחנו כאן בשבילכם – בטלפון, במייל או בכתובת שלנו.",
    keywords: "צור קשר, תמיכה, משלים, טלפון, אימייל, כתובת, פתח תקווהמשלים, משלים פלוס לחיים",
    priority: 0.7
  },
  comingsoon: {
    title: "בקרוב",
    to: "/comingsoon",
    description: "Page under construction",
    keywords: "coming soon, construction",
    priority: 0
  },
  maintenance: {
    title: "תחזוקה",
    to: "/maintenance",
    description: "Site under maintenance",
    keywords: "maintenance, site",
    priority: 0
  },
  pricingPlan: {
    title: "תוכניות מחירים",
    to: "/pricing-plan",
    description: "עיינו במסלולי השירות שלנו ובחרו את התוכנית המתאימה ביותר לצרכים שלכם – אישי, משפחתי או משפחתי פלוס.",
    keywords: "מסלולים, תמחור, תוכניות, רופא עד הבית, שירותי חירום, טיפול ביתי, ייעוץ מומחים, משלים",
    priority: 0.8
  },
  error404: {
    title: "שגיאה 404",
    to: "/error-404",
    description: "Page not found",
    keywords: "error, 404",
    priority: 0
  },
  error500: {
    title: "שגיאה 500",
    to: "/error-500",
    description: "Internal server error",
    keywords: "error, 500",
    priority: 0
  },
  faq: {
    title: "שאלות נפוצות",
    to: "/faq",
    description: "מצאו תשובות לשאלות נפוצות בנוגע לקביעת תורים, פרטיות, ניהול חשבון ועוד.",
    keywords: "שאלות נפוצות, קביעת תורים, ביטול תור, פרטיות, רופאים, מומחים, חשבון משתמש",
    priority: 0.7
  },
 
  register: {
    title: "הרשמה",
    to: "/register",
    priority: 1,
    description: "צור חשבון חדש והצטרף לשירותי הבריאות של משלים – טיפול רפואי אישי, רופא עד הבית ועוד",
    keywords: "הרשמה, פתיחת חשבון, הצטרפות לשירות רפואי, רופא עד הבית, שירותי בריאות, חשבון חדש, טיפול רפואי אישי, ייעוץ רפואי אונליין"
  },
  registerPhone: {
    title: "הרשמה עם טלפון",
    to: "/register-phone",
    description: "הרשם עם מספר הטלפון שלך כדי להתחיל להשתמש בשירותי הבריאות של משלים",
    keywords: " הרשמה, טלפון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
    priority: 0
  },
  login: {
    title: "התחברות",
    to: "/login",
    description: "התחבר לחשבון שלך והמשך ליהנות משירותי הבריאות האישיים של משלים",
    keywords: "התחברות, כניסה לחשבון, גישה לחשבון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
    priority: 1
  },
  partnerLogin: {
    title: "התחברות שותפים",
    to: "/partner-login",
    description: "התחבר לחשבון השותף שלך והמשך ליהנות משירותי הבריאות האישיים של משלים",
    keywords: "התחברות שותפים, כניסה לחשבון שותף, גישה לחשבון שותף, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
    priority: 0
  },
  searchMember: {
    title: "חיפוש חבר",
    to: "/partner/search-member",
    description: "חפש חברים בשירותי הבריאות של משלים",
    keywords: "חיפוש חבר, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
    priority: 0
  },
  checkout: {
    title: "רכישה",
    to: "/checkout",
    description: "הרשמה לתוכנית הבריאות של משלים – רופא עד הבית, ייעוץ רפואי אונליין, בדיקות שגרתיות ועוד",
    keywords: "התחברות, כניסה לחשבון, גישה לחשבון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
    priority: 1
  },
  checkoutChoosePlan: {
    title: "רכישה",
    to: "/checkout/choose-plan",
    description: "הרשמה לתוכנית הבריאות של משלים – רופא עד הבית, ייעוץ רפואי אונליין, בדיקות שגרתיות ועוד",
    keywords: "התחברות, כניסה לחשבון, גישה לחשבון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
    priority: 0
  },
  checkoutReg: {
    title: "רכישה",
    to: "/checkout/register",
    description: "הרשמה לתוכנית הבריאות של משלים – רופא עד הבית, ייעוץ רפואי אונליין, בדיקות שגרתיות ועוד",
    keywords: "התחברות, כניסה לחשבון, גישה לחשבון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
    priority: 0
  },
  checkoutAddtionalInfo: {
  title: "פרטים נוספים",
  to: "/checkout/addtional-info",
  description: "הרשמה לתוכנית הבריאות של משלים – רופא עד הבית, ייעוץ רפואי אונליין, בדיקות שגרתיות ועוד",
  keywords: "התחברות, כניסה לחשבון, גישה לחשבון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
  priority: 0
},
checkoutFamily: {
  title: "פרטי משפחה",
  to: "/checkout/family",
  description: "הרשמה לתוכנית הבריאות של משלים – רופא עד הבית, ייעוץ רפואי אונליין, בדיקות שגרתיות ועוד",
  keywords: "התחברות, כניסה לחשבון, גישה לחשבון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
  priority: 0
},
checkoutPayment: {
  title: "תשלום",
  to: "/checkout/payment",
  description: "הרשמה לתוכנית הבריאות של משלים – רופא עד הבית, ייעוץ רפואי אונליין, בדיקות שגרתיות ועוד",
  keywords: "התחברות, כניסה לחשבון, גישה לחשבון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
  priority: 0
},
checkoutThankYou: {
  title: "תודה",
  to: "/checkout/thank-you",
  description: "הרשמה לתוכנית הבריאות של משלים – רופא עד הבית, ייעוץ רפואי אונליין, בדיקות שגרתיות ועוד",
  keywords: "התחברות, כניסה לחשבון, גישה לחשבון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
  priority: 0
},
forgotPassword: {
  title: "שחזור סיסמה",
  to: "/forgot-password",
  description: "הרשמה לתוכנית הבריאות של משלים – רופא עד הבית, ייעוץ רפואי אונליין, בדיקות שגרתיות ועוד",
  keywords: "התחברות, כניסה לחשבון, גישה לחשבון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
  priority: 0
},
firebase: {
  title: "Firebase",
  to: "/firebase",
  description: "הרשמה לתוכנית הבריאות של משלים – רופא עד הבית, ייעוץ רפואי אונליין, בדיקות שגרתיות ועוד",
  keywords: "התחברות, כניסה לחשבון, גישה לחשבון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
  priority: 0
},
forgotPasswordThankYou: {
  title: "תודה - שחזור סיסמה",
  to: "/forgot-password/thank-you",
  description: "הרשמה לתוכנית הבריאות של משלים – רופא עד הבית, ייעוץ רפואי אונליין, בדיקות שגרתיות ועוד",
  keywords: "התחברות, כניסה לחשבון, גישה לחשבון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
  priority: 0
},
processForgotPassword: {
  title: "אימות שחזור סיסמה",
  to: "/forgot-password/process",
  description: "הרשמה לתוכנית הבריאות של משלים – רופא עד הבית, ייעוץ רפואי אונליין, בדיקות שגרתיות ועוד",
  keywords: "התחברות, כניסה לחשבון, גישה לחשבון, שירותי בריאות, רופא עד הבית, ייעוץ רפואי, טיפול רפואי אישי",
  priority: 0
},

  otpRegister: {
    title: "אימות טלפוני",
    to: "/otp-register",
    description: "אמת את מספר הטלפון שלך",
    keywords: "otp, טלפון",
    priority: 0
  },
  otpLogin: {
    title: "אימות טלפוני",
    to: "/otp-login",
    description: "אמת את מספר הטלפון שלך",
    keywords: "otp, טלפון",
    priority: 0
  },
  articles: {
    title: "מאמרים",
    to: "/articles/:id",
    description: "Read our articles",
    keywords: "articles, blog",
    priority: 0
  },
  doctorToHome: {
    title: "רופא עד הבית",
    to: "/doctor-to-home",
    description: "הזמנת רופא עד הבית – טיפול רפואי מקצועי ומהיר 24/7, בכל מקום בארץ. שירות מושלם לקשישים, בעלי ניידות מוגבלת וכל מי שמעדיף טיפול בבית",
    keywords: "רופא עד הבית, ביקור רופא, טיפול רפואי בבית, רופא פרטי, שירות רפואי עד הבית, רופא לילדים בבית, טיפול דרך הווריד, ייעוץ רפואי בבית, רופא מומחה לבית, רפואה פרטית",
    priority: 1
  },
  nurseToHome: {
    title: "אחות עד הבית",
    to: "/nurse-to-home",
    description: "הזמנת אחות פרטית לבית – טיפול מקצועי, עירויים, חבישות, סיוע לאחר ניתוח וטיפול הוספיס. שירות זמין 24/7 החל מ-195₪.",
    keywords: "אחות עד הבית, טיפול אחותי, ביקור אחות, אחות פרטית, עירוי בבית, חבישות פצעים, טיפול לאחר ניתוח, טיפול הוספיס בבית, אחות להזרקות, טיפול סיעודי, שירותי אחות פרטית, סיוע רפואי בבית",
    priority: 1
  },
  services: {
    title: "שירותים",
    to: "/services",
    description: "הכירו את כתבי השירות של משלים – מגוון תוכניות בריאות מותאמות אישית: ייעוץ מומחים, בדיקות, טיפול בבית, פינוי חירום ועוד",
    keywords: "כתבי שירות, תוכניות בריאות, משלים בריאות, משלים פלוס, משלים עד הבית, שירותים רפואיים, רפואה מונעת, ייעוץ רפואי, פיזיותרפיה, רופא אונליין, ביקור רופא בבית, אבחון רפואי, בדיקות הריון, מעבדת שינה, טיפול בכאב",
    priority: 1
  },
  servicesDetails: {
    title: "פרטי השירות",
    to: "/services/:id",
    description: "פרטי השירות של משלים – מידע על תוכניות הבריאות שלנו, כולל ייעוץ מומחים, בדיקות, טיפול בבית ועוד",
    keywords: "service, details, משלים, תוכניות בריאות, ייעוץ מומחים, בדיקות, טיפול בבית",
    priority: 0
  },
   dashboard: {
  title: "לוח בקרה",
  to: "/dashboard",
  description: "לוח הבקרה של המשתמש",
  keywords: "לוח בקרה, משתמש",
  priority: 0
},
dashboardProfile: {
  title: "פרופיל המשתמש",
  to: "/dashboard/profile",
  description: "פרטי המשתמש בלוח הבקרה",
  keywords: "לוח בקרה, פרופיל",
  priority: 0
},
dashboardNotifications: {
  title: "התראות המשתמש",
  to: "/dashboard/notifications",
  description: "התראות ועדכונים בלוח הבקרה",
  keywords: "לוח בקרה, התראות",
  priority: 0
},
dashboardFamily: {
  title: "בני משפחה",
  to: "/dashboard/family",
  description: "ניהול בני המשפחה בלוח הבקרה",
  keywords: "לוח בקרה, משפחה",
  priority: 0
},
dashboardAppointments: {
  title: "תורים",
  to: "/dashboard/appointments",
  description: "צפייה וניהול תורים בלוח הבקרה",
  keywords: "לוח בקרה, תורים",
  priority: 0
},
dashboardInvoices: {
  title: "חשבוניות",
  to: "/dashboard/invoices",
  description: "צפייה בחשבוניות בלוח הבקרה",
  keywords: "לוח בקרה, חשבוניות",
  priority: 0
},
dashboardCases: {
  title: "מקרים רפואיים",
  to: "/dashboard/cases",
  description: "צפייה במקרים רפואיים בלוח הבקרה",
  keywords: "לוח בקרה, מקרים רפואיים",
  priority: 0
}
}